import React from "react";

const legendItemStyle = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
};

const swatchStyle = (color, borderColor) => ({
  width: "14px",
  height: "14px",
  borderRadius: "3px",
  backgroundColor: color,
  border: `2px solid ${borderColor}`,
  flexShrink: 0,
});

const dividerStyle = {
  width: "1px",
  height: "18px",
  backgroundColor: "#ccc",
  margin: "0 4px",
};

const TableWarnings = () => (
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "12px",
      padding: "6px 10px 12px",
      flexShrink: 0,
      fontSize: "13px",
      color: "#333",
    }}
  >
    <span style={legendItemStyle}>
      <span style={swatchStyle("#ffe6e6", "red")} />
      {"Past Pullout Time"}
    </span>
    <span style={legendItemStyle}>
      <span style={swatchStyle("#ffebcc", "orange")} />
      {"Pullout Time Approaching"}
    </span>
    <span style={dividerStyle} />
    <span style={legendItemStyle}>
      <strong>FD</strong> = Foreign Division
    </span>
    <span style={legendItemStyle}>
      <strong>UAR</strong> = Unattended Relief
    </span>
    <span style={legendItemStyle}>
      <strong>LOOK</strong> = Off Site Parking; See Note to Operators
    </span>
    <span style={dividerStyle} />
    <span style={legendItemStyle}>
      <strong>NRR</strong> = No Run Required
    </span>
    <span style={legendItemStyle}>
      <strong>NDA</strong> = No Driver Available
    </span>
    <span style={legendItemStyle}>
      <strong>NBA</strong> = No Bus Available
    </span>
  </div>
);

export default TableWarnings;
